module.exports = __webpack_public_path__ + "media/images/flags/dm-fbdd9806f1e35c0edbc2ea97d7c994b2.svg";